export const Copyright = () => {
  return (
    <footer className="copyright">
      <p>Company Name @2024. All rights reserved.</p>
    </footer>
  );
};
